import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	restoreDefaultsButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	restoreDefaultsButtonText: {
		id: 'jql-builder-basic-picker.async-select.restore-defaults-button.restore-defaults-button-text',
		defaultMessage: 'Restore defaults',
		description: 'Clicking this button will restore to the default configuration.',
	},
});
export default messages;
